import { render, staticRenderFns } from "./GBPhotoAlbumContentItemAlbum.vue?vue&type=template&id=7891f49c&scoped=true&"
import script from "./GBPhotoAlbumContentItemAlbum.vue?vue&type=script&lang=js&"
export * from "./GBPhotoAlbumContentItemAlbum.vue?vue&type=script&lang=js&"
import style0 from "./GBPhotoAlbumContentItemAlbum.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GBPhotoAlbumContentItemAlbum.vue?vue&type=style&index=1&id=7891f49c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7891f49c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VIcon,VLayout})
